<template>
  <div class="mt-6 container has-text-centered">
    <div class="column is-4 is-offset-4">
      <img src="/img/logo.svg" />
      <hr class="login-hr" />
      <p class="subtitle has-text-black">{{ $t("auth.forgotTitle") }}</p>
      <div class="notification is-info is-light has-text-left">
        {{ $t("auth.forgotConfirmMessage") }}
      </div>

      <div class="box">
        <form @submit.prevent="forgotPasswordSubmit">
          <div class="field">
            <div class="control">
              <input
                class="input is-large"
                type="email"
                placeholder="Your Email"
                required
                autofocus=""
                v-model="form.email"
              />
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input
                class="input is-large"
                type="text"
                placeholder="Your verification code"
                required
                autofocus=""
                v-model="form.code"
              />
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input
                class="input is-large"
                type="password"
                placeholder="New password"
                required
                autofocus=""
                v-model="form.password"
              />
            </div>
            <span class="has-text-danger" style="font-size:10pt">{{
              $t("auth.passwordMessage")
            }}</span>
          </div>

          <button
            class="button is-block is-primary is-large is-fullwidth"
            v-bind:class="{ 'is-loading': isLoad }"
          >
            {{ $t("auth.changePassword") }}
          </button>
        </form>
      </div>
      <div v-if="errorMessage" class="notification is-danger is-light">
        {{ errorMessage }}
      </div>
      <p class="has-text-grey mt-3">
        <router-link :to="{ name: 'authForgotPassword' }">
          {{ $t("auth.forgotResend") }}
        </router-link>
      </p>
      <p class="has-text-grey mt-4">
        <router-link :to="{ name: 'authSignIn' }">
          {{ $t("auth.signIn") }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { ref, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const isLoad = ref(false);

    const form = reactive({
      email: store.getters.email,
      code: null,
      password: "",
    });
    const errorMessage = ref();

    const forgotPasswordSubmit = async () => {
      try {
        isLoad.value = true;
        await Auth.forgotPasswordSubmit(
          form.email,
          String(form.code),
          form.password
        );
        store.commit("setMessage", t("auth.successChangePassword"));
        router.push({ name: "authSignIn" });
      } catch (e) {
        if (e.code == "CodeMismatchException") {
          errorMessage.value = t("auth.errorChangePasswordCode");
        } else if (e.code == "ExpiredCodeException") {
          errorMessage.value = t("auth.errorChangePasswordCodeExpire");
        } else if (e.code == "LimitExceededException") {
          errorMessage.value = t("auth.errorChangePasswordLimit");
        } else if (e.code == "InvalidPasswordException") {
          errorMessage.value = t("auth.errorChangePasswordInvalid");
        } else {
          errorMessage.value = t("auth.errorChangePassword");
        }
        isLoad.value = false;
      }
    };

    return {
      form,
      errorMessage,
      isLoad,
      forgotPasswordSubmit,
    };
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
